import React from 'react';
import { IProps } from './interfaces';
import { Container } from './styles';
import ExchangeResultsInfo from './ResultsInfo/component';
import ExchangeResultsActions from './Actions/component';

export default class ExchangeInfoBar extends React.Component<IProps> {
  render() {
    return (
      <Container>
        <ExchangeResultsInfo />
        <ExchangeResultsActions />
      </Container>
    );
  }
}
